import { Component, OnInit, ɵConsole ,Input } from '@angular/core';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';
@Component({
  selector: 'app-paperless-module',
  templateUrl: './paperless-module.component.html',
  styleUrls: ['./paperless-module.component.sass']
})
export class PaperlessModuleComponent implements OnInit {
  @Input() email;
  @Input() paperless;
  public newEmail;
  @Input() currentBan;
  @Input() loadingData;
  @Input() viewPaper;
  
  public selectBan;
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  public tabActive='Dashboard';
  constructor(private services: Service,private loadingScreenService :LoadingScreenService, private global:GlobalService) { }

  ngOnInit() {
    this.paperless=JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).qualification.RefererResponse.paperless;
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    if(this.loadingData!=false){

    }
    else{

      this.newEmail='';
    }
    if(this.viewPaper==null||this.viewPaper==undefined){
      this.viewPaper=0;
    }
  }
  updatepaperless(){
    this.selectBan=atob(sessionStorage.getItem("selectBan"));
    this.global.validateSession();
    if(this.paperless==false){
      this.loadingScreenService.startLoading();
      this.token=sessionStorage.getItem("token");
        this.services.updatePaperless(this.selectBan,this.token).subscribe(data =>{
          if(data.HasError ==false){
            this.paperless=true;
            this.loadingScreenService.stopLoading();
            if(data.ErrorDesc!=''&&data.ErrorDesc!=undefined&&data.ErrorDesc!=null){
              this.global.notif(data.ErrorDesc);
            }
          }
          else{
            this.loadingScreenService.stopLoading();
            this.global.notif(data.ErrorDesc);
          }
        });  
    }
    else{
      this.paperless=false;
    }
  }

}